import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_PREVENTIVE_TASK,
  CLEAR_PREVENTIVE_TASKS,
  CLEAR_PREVENTIVE_TASK_RESOURCE,
  FLAG_GETTING_PREVENTIVE_TASK_RESOURCE,
  FLAG_GETTING_PREVENTIVE_TASKS,
  FLAG_PREVENTIVE_TASK_ACTIVITY,
  FLAG_PREVENTIVE_TASK_HAS_RESOURCE,
  GET_PREVENTIVE_TASK,
  GET_PREVENTIVE_TASK_RESOURCE,
  GET_PREVENTIVE_TASKS,
} from '../../../actions/types/task-schedule';

const INITIAL_STATE = Immutable.Map({
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  resource: Immutable.Map({
    content: Immutable.List(),
    loading: false,
  }),
  hasResource: false,
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_GETTING_PREVENTIVE_TASKS:
      return state.setIn(['all', 'loading'], payload);

    case GET_PREVENTIVE_TASKS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));

    case CLEAR_PREVENTIVE_TASKS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );

    case FLAG_PREVENTIVE_TASK_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );

    case GET_PREVENTIVE_TASK:
      return state.setIn(['current', 'content'], Immutable.Map(payload));

    case CLEAR_PREVENTIVE_TASK:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));

    case FLAG_PREVENTIVE_TASK_HAS_RESOURCE:
      return state.set('hasResource', payload);

    case FLAG_GETTING_PREVENTIVE_TASK_RESOURCE:
      return state.setIn(['resource', 'loading'], payload);

    case GET_PREVENTIVE_TASK_RESOURCE:
      return state.setIn(['resource', 'content'], Immutable.List(payload));

    case CLEAR_PREVENTIVE_TASK_RESOURCE:
      return state.setIn(['resource'], INITIAL_STATE.getIn(['resource']));

    default:
      return state;
  }
};
